import { create, destroy, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { SlidingPane } from '@holmescorp/base-widgets/sliding-pane';
import { subscribe } from 'pub-sub';
import { createNlsMiddleware, lccstate, userstate, registry } from 'lcc-state';
import { delay } from '@holmescorp/common';
import { viewport } from '../support/viewport';
const icache = createICacheMiddleware();
const nls = createNlsMiddleware('settings');
const factory = create({
    icache,
    destroy,
    theme,
    nls,
    lccstate,
    userstate
}).properties();
export const GlossaryPane = factory(({ properties, middleware: { icache, destroy, nls } }) => {
    const { onClose } = properties();
    icache.getOrSet('aboutToChange', false);
    const open = icache.getOrSet('open', () => {
        const hnd = [
            subscribe('glossary/open', async () => {
                icache.set('aboutToChange', true);
                await delay(200);
                icache.set('open', true);
            }),
            subscribe('close-all/panes', () => {
                icache.set('open', false);
            })
        ];
        destroy(() => {
            hnd.forEach((h) => h.destroy());
        });
        return false;
    });
    const { messages: { glossary_title = '[settings] glossary_title' } } = nls();
    const { vw } = viewport();
    const xqa = `glossary-pane-${open}`;
    return w(SlidingPane, {
        xqa,
        key: 'glossary-pane',
        open,
        align: 'right',
        underlay: true,
        title: glossary_title,
        width: Math.min(vw, 1024),
        onRequestClose: () => {
            icache.set('open', false);
            icache.set('aboutToChange', async () => {
                await delay(500);
                return true;
            });
            onClose && onClose();
        }
    }, [w('Glossary', {})]);
});
registry.define('GlossaryPane', GlossaryPane);
